module.exports = __webpack_public_path__ + "img/mdb-vue-ui-kit.0c677dde.jpg";